jQuery(($) => {
  $.RegistrationEntryPlugin = (options) => {
    const defaults = {
      entryRequestUrl: null,
      heimdallToken: null,
      csrfTokenName: null,
      csrfTokenValue: null,
    };
    const settings = $.extend({}, defaults, options);
    const $spinner = $('.js-registration-entry-spinner');
    const $entryPending = $('.js-registration-entry-pending');
    const $entrySucceeded = $('.js-registration-entry-succeeded');
    const $entryDenied = $('.js-registration-entry-denied');
    let isPolling = false;
    let pollAjax = null;
    let entryPolling;

    /**
         * It worked! Send the user to their registration page
         * @param destination
         */
    const entrySucceeded = ({ destination }) => {
      clearInterval(entryPolling);
      window.location.href = destination;
    };

    /**
         * Something terrible has happened. Tell the user
         * @TODO: tell the user why
         */
    const entryFailed = () => {
      $spinner.addClass('hidden');
      $entryDenied.removeClass('hidden');
      $entryPending.addClass('hidden');
      $entrySucceeded.addClass('hidden');
    };

    /**
         * Ajax came back with a response, remove the spinner
         */
    const pollingFinished = () => {
      isPolling = false;
    };

    /**
         * Ask the server nicely if we can can come party
         */
    const pollForEntry = () => {
      if (isPolling) {
        return;
      }

      isPolling = true;

      $spinner.removeClass('hidden');

      $entryPending.removeClass('hidden');
      $entryDenied.addClass('hidden');
      $entrySucceeded.addClass('hidden');

      pollAjax = $.ajax({
        url: settings.entryRequestUrl,
        type: 'post',
        data: {
          heimdallToken: settings.heimdallToken,
          [settings.csrfTokenName]: settings.csrfTokenValue,
        },
        dataType: 'json',
      });

      pollAjax.done(entrySucceeded);
      pollAjax.fail(entryFailed);
      pollAjax.always(pollingFinished);
    };

    /**
         * Start your engines
         */
    const initialize = () => {
      pollForEntry();
      entryPolling = setInterval(pollForEntry, 10000);
    };

    initialize();
  };
});
